// extracted by mini-css-extract-plugin
export default {"noresults":"styles_noresults__nAEmq"};